

























































































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientMergeConflict } from '@/shared/data-management/client-merge-conflict';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ClientMergeConflicts extends Vue {
    @Prop({ required: true }) private priorityClient!: ClientAccount;
    @Prop({ required: true }) private mergeClient!: ClientAccount;
    @Prop({ required: true }) private mergeConflicts!: Array<ClientMergeConflict>;

    private get priorityClientDescription(): string {
        return `${this.priorityClient.accountNo} - ${this.priorityClient.firstName == null ? '' : this.priorityClient.firstName.trim()} ${this.priorityClient.lastName == null ? '' : this.priorityClient.lastName.trim()}`;
    }

    private get mergeClientDescription(): string {
        return `${this.mergeClient.accountNo} - ${this.mergeClient.firstName == null ? '' : this.mergeClient.firstName.trim()} ${this.mergeClient.lastName == null ? '' : this.mergeClient.lastName.trim()}`;
    }
}
